//#region Libraries
import { 
    Routes, 
    Route, 
    Navigate
} from "react-router-dom";
//#endregion
//#region Components
import Form from "./Form";
import Preloader from "components/Preloader/Preloader";
import CheckEventExistence from "../../components/CheckEventExistence/CheckEventExistence";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
//#endregion

const ManualLoadingForm = () => {
    const loadingRequest = useLoadingRequest();
    return (
        <>
        <Preloader {...loadingRequest.value}/>
        <Routes>
            <Route 
                path="crear" 
                element={<Form isCreate loadingRequest={loadingRequest}/>}/>
            <Route 
                path="editar"
                element={
                    <CheckEventExistence
                        loadingRequest={loadingRequest}
                        defaultPath={ABSOLUTE_PATHS.CREATE_EVENT_MANUAL_LOADING}>
                        <Form loadingRequest={loadingRequest}/>
                    </CheckEventExistence>}/>
            <Route 
                path="*" 
                element={
                    <Navigate 
                        to={ABSOLUTE_PATHS.CREATE_EVENT_MANUAL_LOADING}
                        replace/>}/>
        </Routes>
        </>
    );
}

export default ManualLoadingForm;